import { log } from '@hotjar/insights-common/lib/log';

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `hotjar` namespace.
 */
export const tagRecording = (tag: string): void => {
  if (window.hj) {
    log.debug(`Hotjar: Tagging recording with "${tag}"`);
    window.hj('tagRecording', [tag]);
  }
};

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `hotjar` namespace.
 */
export const trigger = (trig: string): void => {
  if (window.hj) {
    log.debug(`Hotjar: Javascript trigger "${trig}"`);
    window.hj('trigger', trig);
  }
};

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `hotjar` namespace.
 * Track a Virtual Page View.
 */
export const trackVirtualPageView = (path: string): void => {
  if (window.hj) {
    log.debug(`Hotjar: Tracking virtual page view ${path}`);
    window.hj('vpv', path);
  }
};

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `hotjar` namespace.
 */
export const event = (actionName: string): void => {
  if (window.hj) {
    log.debug(`Hotjar: Event firing ${actionName}`);
    window.hj('event', actionName);
  }
};
